// extracted by mini-css-extract-plugin
module.exports = {"title":"HeroTitle_title__ZgnIi","subtitle":"HeroTitle_subtitle__1_B5-"};